export const SET_MESSAGE_CONFIRMACAOEMAIL = "SET_MESSAGE_CONFIRMACAOEMAIL";
export const SET_LOADING_VALUE = "SET_LOADING_VALUE";
export const SET_ERROR_VALUE = "SET_ERROR_VALUE";